module.exports = __webpack_public_path__ + "img/calendar.5cbc8f03.svg";